export default "__VITE_ASSET__BxAyV13L__"